import $ from 'jquery';

/**
 * @description - class for connecting to twitter flight events
 * @class Messaging
 */
export default class Messaging {

    constructor() {
        this.subscribe = this.subscribe.bind(this);
        this.publish = this.publish.bind(this);
        this.namespace = `events-${Date.now()}-${Math.random()}`;
        this.events = [];
    }

    /**
     * @description - method to 'connect' to events
     * @param {array} events - array of all events to listen to
     * @param {function} callback - function invoked when an event is fired
     * @memberof Messaging
     */
    subscribe(events, callback) {
        this.events.push(events);
        if (!events) {
            console.warn('No event{s} passed, failing to register');
            return;
        };

        if (Array.isArray(events)) {
            //events.event is uid -> 'ui:navigate'
            events.map(event => {
                $(document).on(`${event}.${this.namespace}`, callback);
            });
        } else {
            $(document).on(`${event}.${this.namespace}`, callback);
        }
    }

    /**
     * @description - publish event
     * @param {string} event
     * @param {(object|string)} payload
     * @memberof Messaging
     */
    publish(event, payload) {
        // this.ConnectedToFlight.prototype.publishEvent(event, payload);
        $(document).trigger(event, payload);
    }

    teardown() {
        this.events.map(event => {
            $(document).off(`${event}.${this.namespace}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/packages/react/messaging.js